// Primary colors
export const CORAL = "#FE5D5D";
export const INK = "#615EF7";
export const INK_HOVER = "#7371FF";
export const SKY = "#A2C5FB";
export const CLOUD = "#E3EEFF";
export const SEA_FOAM = "#68F2D2";
export const LOGIN_BACKGROUND = "#E3EEFF";
export const INCOMPLETE_GRAY = "#CCCCCC";
export const GRAY = "#666666";

// RGBA values
export const CORAL_RGBA = (a: number) => `rgba(254, 93, 93, ${a})`;
export const INK_RGBA = (a: number) => `rgba(97, 94, 247, ${a})`;
export const SKY_RGBA = (a: number) => `rgba(162, 197, 251, ${a})`;
export const CLOUD_RGBA = (a: number) => `rgba(227, 238, 255, ${a})`;
export const SEA_FOAM_RGBA = (a: number) => `rgba(104, 242, 210, ${a})`;
